<script lang="ts" setup>
const { t } = useI18n();
</script>

<template>
  <div class="orderCreatingLayout">
    <div class="orderCreatingLayout__container">
      <h1 class="orderCreatingLayout__title">{{ t('title') }}</h1>
      <div class="orderCreatingLayout__content">
        <OrderRecipientData />
        <OrderObtainingMethod />
        <!-- TODO: надо ли еще -->
        <!--      <OrderAddFree />-->
        <!--      <OrderSubscriptionExists />-->
        <OrderPaymentMethods />
      </div>

      <OrderCouponForm class="orderCreatingLayout__coupon" />

      <OrderPaymentButton class="orderCreatingLayout__buy" />
    </div>
  </div>
</template>

<i18n>
ru:
  title: Оформление заказа

en:
  title: Order creation
</i18n>

<style lang="scss">
.orderCreatingLayout {
  padding: 20px;

  @include mq('sm') {
    padding: 0;
  }

  &__container {
    max-width: 570px;
    width: 100%;
    margin: 0 auto;

    @include mq('sm') {
      padding: 0 16px 24px;
    }
  }

  &__title {
    font-size: 34px;
    line-height: 120%;
    text-align: center;
    color: #121212;
    margin-top: 0;
    margin-bottom: 40px;

    @include mq('md') {
      font-size: 24px;
      line-height: 32px;
      margin-top: 36px;
      margin-bottom: 24px;
      text-align: start;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  & &__coupon {
    margin-top: 24px;

    @include mq('none', 'md') {
      display: none;
    }
  }

  & &__buy {
    display: none;
    margin-top: 24px;

    @include mq('md') {
      display: block;
    }
  }
}
</style>
